import { useSelector } from "react-redux";
import { RootState } from "../../../app/store";
import { useEffect } from "react";
import configUrls from "../../../config/configUrls";
import { useDarCienciaProcessoMutation } from "../processoApiSlice";
import IconButton from '@mui/material/IconButton';
import ThumbUpOffAltOutlinedIcon from '@mui/icons-material/ThumbUpOffAltOutlined';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import { useNavigate } from 'react-router-dom'; // Importação para navegação
import { useSnackbar } from "notistack";
import errorFormat from "../../../utils/errorFormat";
import ThumbUp from "@mui/icons-material/ThumbUp";

export const ButtonPressDarCiencia = () => {
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate(); // Hook para navegação
  const [createProcesso, status] = useDarCienciaProcessoMutation();
  // Hook para seleção do processo
  const { processoSelecionado } = useSelector((state: RootState) => state.processoSelecionado);



  /*
  // Efeito para verificar se o processo foi selecionado
  useEffect(() => {
    if (!processoSelecionado) {
      alert("Nenhum processo foi previamente selecionado");
      navigate(configUrls.PROCESSO_LIST_RT); // Usando useNavigate para navegação
    }
  }, [processoSelecionado, navigate]);
  */

  // Função para tratar o clique no botão
  const handleButtonPress = async () => {
    if (processoSelecionado) {
      try {
        // Dispara a mutação para "dar ciência" ao processo selecionado
        await createProcesso({ id: processoSelecionado.id });
        //
      } catch (e) {
        console.error("Erro ao dar ciência ao processo:", e);
        enqueueSnackbar("Ocorreu um erro ao dar ciência ao processo!", { variant: "error" });
      }
    } else {
      enqueueSnackbar("Nenhum processo foi previamente selecionado", { variant: "error" });
    }
  };

  useEffect(() => {
    if (status.isError) {
      //enqueueSnackbar("Ocorreu um erro ao dar ciência ao processo!", { variant: "error" })
      const erroReturn: string = errorFormat(status);
      enqueueSnackbar(erroReturn, { variant: "error" })
    }

    if (status.isSuccess) {
      enqueueSnackbar("Ciência dada ao processo com sucesso!", { variant: "success" });
      navigate(configUrls.PROCESSO_CIENCIA_LIST);
    }
  }, [status]);

  return (
    <IconButton
      color="secondary"
      size="large"
      onClick={handleButtonPress}
      disabled={status.isLoading}
    >
      {processoSelecionado?.deuCiencia ? <ThumbUp /> : <ThumbUpOffAltOutlinedIcon />}

    </IconButton>
  );
};
